// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"536c4afa","845":"a251fe6a"}[chunkId] + ".chunk.js";
};